"use strict";

function _interopDefault(e) {
  return e && "object" == typeof e && "default" in e ? e.default : e;
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var reactRouter = require("react-router"),
    React = _interopDefault(require("react")),
    history = require("history");

require("prop-types"), require("tiny-warning");

var invariant = _interopDefault(require("tiny-invariant"));

function _extends() {
  return (_extends = Object.assign || function (e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];

      for (var o in t) {
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function _inheritsLoose(e, r) {
  e.prototype = Object.create(r.prototype), (e.prototype.constructor = e).__proto__ = r;
}

function _objectWithoutPropertiesLoose(e, r) {
  if (null == e) return {};
  var t,
      o,
      n = {},
      a = Object.keys(e);

  for (o = 0; o < a.length; o++) {
    t = a[o], 0 <= r.indexOf(t) || (n[t] = e[t]);
  }

  return n;
}

var BrowserRouter = function (n) {
  function e() {
    for (var e, r = arguments.length, t = new Array(r), o = 0; o < r; o++) {
      t[o] = arguments[o];
    }

    return (e = n.call.apply(n, [this].concat(t)) || this).history = history.createBrowserHistory(e.props), e;
  }

  return _inheritsLoose(e, n), e.prototype.render = function () {
    return React.createElement(reactRouter.Router, {
      history: this.history,
      children: this.props.children
    });
  }, e;
}(React.Component),
    HashRouter = function (n) {
  function e() {
    for (var e, r = arguments.length, t = new Array(r), o = 0; o < r; o++) {
      t[o] = arguments[o];
    }

    return (e = n.call.apply(n, [this].concat(t)) || this).history = history.createHashHistory(e.props), e;
  }

  return _inheritsLoose(e, n), e.prototype.render = function () {
    return React.createElement(reactRouter.Router, {
      history: this.history,
      children: this.props.children
    });
  }, e;
}(React.Component),
    resolveToLocation = function resolveToLocation(e, r) {
  return "function" == typeof e ? e(r) : e;
},
    normalizeToLocation = function normalizeToLocation(e, r) {
  return "string" == typeof e ? history.createLocation(e, null, null, r) : e;
},
    forwardRefShim = function forwardRefShim(e) {
  return e;
},
    forwardRef = React.forwardRef;

function isModifiedEvent(e) {
  return !!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
}

void 0 === forwardRef && (forwardRef = forwardRefShim);

var LinkAnchor = forwardRef(function (e, r) {
  var t = e.innerRef,
      o = e.navigate,
      n = e.onClick,
      a = _objectWithoutPropertiesLoose(e, ["innerRef", "navigate", "onClick"]),
      i = a.target,
      c = _extends({}, a, {
    onClick: function onClick(r) {
      try {
        n && n(r);
      } catch (e) {
        throw r.preventDefault(), e;
      }

      r.defaultPrevented || 0 !== r.button || i && "_self" !== i || isModifiedEvent(r) || (r.preventDefault(), o());
    }
  });

  return c.ref = forwardRefShim !== forwardRef && r || t, React.createElement("a", c);
}),
    Link = forwardRef(function (e, a) {
  var r = e.component,
      i = void 0 === r ? LinkAnchor : r,
      c = e.replace,
      f = e.to,
      u = e.innerRef,
      s = _objectWithoutPropertiesLoose(e, ["component", "replace", "to", "innerRef"]);

  return React.createElement(reactRouter.__RouterContext.Consumer, null, function (r) {
    r || invariant(!1);

    var t = r.history,
        e = normalizeToLocation(resolveToLocation(f, r.location), r.location),
        o = e ? t.createHref(e) : "",
        n = _extends({}, s, {
      href: o,
      navigate: function navigate() {
        var e = resolveToLocation(f, r.location);
        (c ? t.replace : t.push)(e);
      }
    });

    return forwardRefShim !== forwardRef ? n.ref = a || u : n.innerRef = u, React.createElement(i, n);
  });
}),
    forwardRefShim$1 = function forwardRefShim$1(e) {
  return e;
},
    forwardRef$1 = React.forwardRef;

function joinClassnames() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++) {
    r[t] = arguments[t];
  }

  return r.filter(function (e) {
    return e;
  }).join(" ");
}

void 0 === forwardRef$1 && (forwardRef$1 = forwardRefShim$1);
var NavLink = forwardRef$1(function (e, s) {
  var r = e["aria-current"],
      l = void 0 === r ? "page" : r,
      t = e.activeClassName,
      p = void 0 === t ? "active" : t,
      h = e.activeStyle,
      R = e.className,
      d = e.exact,
      v = e.isActive,
      y = e.location,
      m = e.strict,
      w = e.style,
      _ = e.to,
      L = e.innerRef,
      x = _objectWithoutPropertiesLoose(e, ["aria-current", "activeClassName", "activeStyle", "className", "exact", "isActive", "location", "strict", "style", "to", "innerRef"]);

  return React.createElement(reactRouter.__RouterContext.Consumer, null, function (e) {
    e || invariant(!1);

    var r = y || e.location,
        t = normalizeToLocation(resolveToLocation(_, r), r),
        o = t.pathname,
        n = o && o.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1"),
        a = n ? reactRouter.matchPath(r.pathname, {
      path: n,
      exact: d,
      strict: m
    }) : null,
        i = !!(v ? v(a, r) : a),
        c = i ? joinClassnames(R, p) : R,
        f = i ? _extends({}, w, {}, h) : w,
        u = _extends({
      "aria-current": i && l || null,
      className: c,
      style: f,
      to: t
    }, x);

    return forwardRefShim$1 !== forwardRef$1 ? u.ref = s || L : u.innerRef = L, React.createElement(Link, u);
  });
});
Object.keys(reactRouter).forEach(function (e) {
  "default" !== e && Object.defineProperty(exports, e, {
    enumerable: !0,
    get: function get() {
      return reactRouter[e];
    }
  });
}), exports.BrowserRouter = BrowserRouter, exports.HashRouter = HashRouter, exports.Link = Link, exports.NavLink = NavLink;